module.exports = __webpack_public_path__ + "media/site/images/case_studies/sensor_cloud/dashboard2@2x-aecf140485a712bbf3ed42e248916f32.png";